import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import MetaView from "./meta";
import ReportView from "./report";
import templates from "../../../../../../utils/templates";

const channel = Radio.channel("global");

const DEFAULTS = {
  template: templates.find("layout", "meta_and_report"),
};

class View extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  regions() {
    return {
      meta: ".meta",
      report: ".report",
    };
  }

  childEvents() {
    return {
      "modal:close": "_hide",
    };
  }

  initialize() {
    // localize models passed in via options
    this.metaModel = this.options.data.chooserMetadata || null;
    this.chartModel = this.options.data.chartModel || null;

    // load tab data on activation
    this.listenTo(channel, "tab-activated", this._onActivate);
  }

  // default tab, load views immediately
  onBeforeShow() {
    this.meta.show(
      new MetaView({
        model: this.metaModel,
      })
    );

    // pass a route config object
    this.report.show(
      new ReportView({
        routeConfig: {
          chartId: this.model.getChartReviewId(),
          drgId: this.model.getId(),
          cmRunSid: this.metaModel.getCmRunSid(),
        },
      })
    );
  }

  // reload views on reactivation
  _onActivate(tab) {
    if ("tab-matchpoint-claim-matches" === tab) {
      this.meta.show(
        new MetaView({
          model: this.metaModel,
        })
      );

      // pass a route config object
      this.report.show(
        new ReportView({
          routeConfig: {
            chartId: this.model.getChartReviewId(),
            drgId: this.model.getId(),
            cmRunSid: this.metaModel.getCmRunSid(),
          },
        })
      );
    }
  }

  _hide() {
    // notify parent layout of this change
    this.triggerMethod("modal:close");
  }
}

export { View as default };
